import React from 'react';
import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          rbots откри грешка 404!
        </p>
        <p>
          Оп, страницата която търсите е недостъпна или не съществува.
          Може да се върнете към 
        <a
          className="nested-link"
          href="http://rbots.bg"
          target="_blank"
          rel="noopener noreferrer"
        >
          началната страница
        </a>.
        </p>
      </header>
    </div>
  );
}

export default App;
